"use client"

import { useRouter } from "next/navigation"

interface SortSelectProps {
  currentSort: string
  baseUrl: string
  searchParams: Record<string, string>
}

const sortOptions = [
  { name: "Newest First", value: "age:newest" },
  { name: "Oldest First", value: "age:oldest" },
  { name: "Price: Low to High", value: "price:lowest" },
  { name: "Price: High to Low", value: "price:highest" },
]

export default function SortSelect({ currentSort, baseUrl, searchParams }: SortSelectProps) {
  const router = useRouter()

  function handleChange(e: React.ChangeEvent<HTMLSelectElement>) {
    const params = new URLSearchParams()
    Object.entries(searchParams).forEach(([key, value]) => {
      if (key !== "sort" && key !== "page" && value) {
        params.set(key, value)
      }
    })
    params.set("sort", e.target.value)
    router.push(`${baseUrl}?${params.toString()}`)
  }

  return (
    <div className="flex items-center gap-2">
      <label htmlFor="sort" className="text-sm text-gray-500 hidden sm:inline">
        Sort:
      </label>
      <select
        id="sort"
        value={currentSort}
        onChange={handleChange}
        className="rounded-lg border border-gray-300 bg-white px-3 py-1.5 text-sm focus:border-amber-500 focus:outline-none focus:ring-1 focus:ring-amber-500"
      >
        {sortOptions.map((option) => (
          <option key={option.value} value={option.value}>
            {option.name}
          </option>
        ))}
      </select>
    </div>
  )
}
